<template>
  <strategies-template />
</template>

<script>
import StrategiesTemplate from "@/app/strategies/components/templates/StrategiesTemplate.vue";

export default {
  components: {
    StrategiesTemplate,
  },
};
</script>
